<template>
  <div class="animated fadeIn companies--companies-list d-flex flex-column">
    <fixed-header
      title="Companies"
      :records="isValidCompanyCountValues ? companyCounts.allCompaniesCount : null"
      hideNewOfferBtn
      hideBackBtn
      >
      <div class="buttons-panel m-0">
        <b-button @click="$bvModal.show('import-company')" v-if="checkClaim(CAN_ADD_COMPANY)" class="mr-2" size="sm" variant="primary">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Import Companies
        </b-button>
        <b-button @click="$bvModal.show('assign-buyer-seller')" v-if="checkClaim(CAN_EDIT_COMPANY)" class="mr-2" size="sm" variant="primary" :disabled="!checkedRowItemIdsArr.length">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Assign
        </b-button>
        <b-button variant="danger" @click="onMultiDeleteCompanies" class="mr-2" size="sm" :disabled="!checkedRowItemIdsArr.length || onMultiDeleting"> 
          <i class="fa fa-trash"></i>
          Delete
        </b-button>
        <b-button v-if="checkClaim(CAN_ADD_REQUIREMENTS)" class="mr-2" @click="redirectToAdd" size="sm" variant="primary">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Add requirement
        </b-button>
        <b-modal size="sm" ok-title="Save" id="assign-buyer-seller" title="Assign Buyer/Sales Representative" @ok="assignBuyerSeller">
          <b-row>
            <b-col cols="6">
              <b-form-group label="Sales Rep">
                <b-form-select v-model="assignSeller">
                  <option value=""></option>
                  <option v-for="(selectRep, indexRep) in sortSelect(salesReps)" :key="indexRep" :value="selectRep.id">
                    {{ selectRep.name }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Buyers Rep">
                <b-form-select v-model="assignBuyer">
                  <option value=""></option>
                  <option v-for="(selectRep, indexRep) in sortSelect(buyerReps)" :key="indexRep" :value="selectRep.id">
                    {{ selectRep.name }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Alternate Sales Rep">
                <b-form-select v-model="assignSeller2">
                  <option value=""></option>
                  <option v-for="(selectRep, indexRep) in sortSelect(salesReps)" :key="indexRep" :value="selectRep.id">
                    {{ selectRep.name }}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal size="sm" ok-title="Import" @shown="onShowImportModal"
          id="import-company" title="Import Company" no-close-on-backdrop>
          <b-row>
            <b-col>
              <a href="/files/CompanyImportFile.xlsx" download>
                <i class="fa fa-file"></i>
                Download Template File
              </a>
              <b-form-group label="Company Import File" class="required mt-2">
                <b-form-file
                  multiple
                  :disabled="isImporting || !onImporting"
                  v-model="filesUpload"
                  :file-name-formatter="formatNames"
                  accept=".xlsx"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                ></b-form-file>
                <b-form-invalid-feedback>Please select valid file to import companies.</b-form-invalid-feedback>
              </b-form-group>
              <b-row class="mt-2">
                <b-col>
                  <b-form-select v-model="importSalesRep" :disabled="isImporting || !onImporting">
                    <option :value="null"> -- Sales Rep -- </option>
                    <option v-for="(rep, i) in salesReps" :key="i" :value="rep.id">{{rep.name}} </option>
                  </b-form-select>
                </b-col>
                <b-col>
                  <b-form-select v-model="importBuyerRep" :disabled="isImporting || !onImporting">
                    <option :value="null"> -- Buyer Rep -- </option>
                    <option v-for="(rep, i) in buyerReps" :key="i" :value="rep.id">{{rep.name}} </option>
                  </b-form-select>
                </b-col>
              </b-row>
              
              <br/>
              <b-textarea
                id="statusArea"
                v-model="importLog"
                disabled
                :style="`width: 100%`"
                rows="10"
              />
            </b-col>
          </b-row>
          <template slot="modal-footer">
              <b-button @click="$bvModal.hide('import-company')">{{isImporting ? 'Hide' : 'Close' }}</b-button>
              <b-button variant="primary" @click="onImportCompanies" v-if="onImporting" :disabled="isImporting">Import</b-button>
              <b-button @click="onShowImportModal" v-if="!onImporting" variant="warning">New Import</b-button>
          </template>
        </b-modal>
        <edit-company class="mr-2" isToRedirect></edit-company>
        
        <button type="button" @click="getRequirementsExcel()" class="btn btn-secondary btn-sm mr-2">
          <i class="fa fa-download"></i>
        </button>
      </div>
    </fixed-header>

    <b-card>
      <div>
        <advanced-filters :name="filters.name" @search="handleSearch" :toggleAdvancedFilters="toggleAdvancedFilters" />
        <b-tabs fill active-nav-item-class="font-weight-bold text-uppercase" lazy>
          <b-tab v-for="type in tabTypes" :key="type.id" @click.stop="onChangeTab(type.id)" :active="filters.accountTypeId==type.id">
            <template v-slot:title>
              {{ type.name }}  &nbsp;<b-badge variant="primary" v-if="isValidCompanyCountValues">{{ companyCounts[type.countVar] }}</b-badge>
            </template>
            <div class="d-flex justify-content-start align-items-end mb-2" v-if="filters.accountTypeId == 3" >
              <b-form-group label="Vendor Type" class="mr-3">
                <b-form-select v-model="filters.vendorType" @change="onCustomFilterSearch">
                  <option :value="null">All</option>
                  <option v-for="(select, index) in sortSelect(vendorTypes)" v-bind:key="index"
                        v-bind:value="select.id">{{select.name}}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group class="mr-3">
                <b-form-checkbox v-model="filters.isShowAvl" @input="onCustomFilterSearch" switch>
                  Show AVL
                </b-form-checkbox>     
              </b-form-group>
              <b-form-group>
                <b-form-checkbox v-model="filters.isShowNonAvl" @input="onCustomFilterSearch" switch>
                  Show Non-AVL
                </b-form-checkbox>     
              </b-form-group>
            </div>
            
            <keep-alive>
              <grid-component
                isResizable
                isReorderable
                isSortable
                :canEdit="checkClaim(CAN_EDIT_COMPANY)"
                :canDelete="checkClaim(CAN_DELETE_COMPANY)"
                :gridId="gridId"
                :pageable="pageable"
                :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
                :take="pageInfo.pageSize"
                :itemData="itemData"
                :navigationField="'name'"
                :pageSizes="pageInfo.pageSize"
                :totalItems="pageInfo.totalItems"
                :fields="fields"
                :sortBy="pageInfo.sortBy"
                :sortOrder="pageInfo.sortOrder"
                :sortMethod="sortGrid"
                :onEdit="openEdit"
                :onDelete="onDelete"
                :handleRowClick="handleRowClick"
                :styleCustom="filters.accountTypeId == 3 ? 'height:590px' : 'height: 645px'"
                @getData="onGetData"
                :checkBoxValues="checkedRowItemIdsArr"
                @checkedItem="checkedRowItemIdsArr=$event"
                :isTblLoader="tblLoader"
              />      
            </keep-alive>
            
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import StarRating from 'vue-star-rating';

import { dateTime } from '@/shared/filters';
import { ACTIVE, GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
import { prepareColumnsData, withAllOption } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';

import EditCompany from './components/EditCompany';
import AdvancedFilters from './components/AdvancedFilters';
import companiesFields from './fields';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
  components: {
    StarRating,
    EditCompany,
    AdvancedFilters,
    GridSettings,
    FixedHeader,
    GridComponent
  },
  metaInfo: () => ({
    title: 'Companies',
  }),
  data() {
    return {
      withAllOption,
      active: ACTIVE,
      prepareColumnsData,
      filtersVisible: false,
      fields: companiesFields,
      gridId: GRID_ID.COMPANY,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      checkedRowItemIdsArr: [],
      assignSeller : '',
      assignBuyer: '',
      assignSeller2: '',
      isImporting: false,
      filesUpload: null,
      logStatus: 'Waiting for import file to be uploaded...',
      onImporting: true,
      onMultiDeleting: false,
      tabTypes: [
        { id: null, name: "All", countVar: 'allCompaniesCount' },
        { id: 1, name: "Customers", countVar: 'customersCount' },
        { id: 5, name: "Prospects", countVar: 'prospectsCount' },
        { id: 6, name: "Leads", countVar: 'leadsCount' },
        { id: 3, name: "Vendors", countVar: 'vendorsCount' }        
      ],
      importSalesRep: null,
      importBuyerRep: null
    };
  },
  computed: {
    ...mapState('companies', ['companiesList']),
    ...mapGetters('companies', [
      // 'companiesList',
      'importLog',
      'pageInfo',
      'delete',
      'lastOpenedId',
      'tblLoader',
      'filters'
    ]),
    ...mapState('timezones', ['timezones']),
    ...mapState('accountTypes', ['accountTypes']),
    ...mapGetters('account', ['gridSettingsById', 'userId']),
    ...mapState('salesReps', ['salesReps']),
    ...mapState('buyerReps', ['buyerReps']),
    ...mapGetters('companies', ['companyCountByUserId']),
    ...mapState('lookup', ['vendorTypes']),
    gridSettings() {
      return this.gridSettingsById(GRID_ID.COMPANY);
    },
    itemData() {
      if (this.companiesList == undefined || !this.companiesList.length) return [];
      return this.companiesList.map((company) => ({ ...company, selected: company.id === this.selectedRowItemId }));
    },
    companyCounts() {
      return this.companyCountByUserId(this.userId);
    },
    isValidCompanyCountValues() {
      return this.companyCounts.id != '';
    }
  },
  filters: {
    dateTime,
  },
  methods: {
    // ...mapMutations('companies', [
    //   'setLastOpenedId',
    //   'setCheckedRowItemIds',
    // ]),
    ...mapMutations('companies', [
      'setItem',
      'appendImportLog'
    ]),
    ...mapActions('companies', [
      'getCompanies',
      'getCompaniesExcel',
      // 'getPage',
      'sortGrid',
      'search',
      // 'advancedSearch',
      'deleteRecord',
      // 'selectCompany',
      'setSalesperson',
      'setAlternativeSalesperson',
      'setBuyer',
      'importCompanies',
      'multiDeleteCompanies',
      'getCompanyCountByUserId'
      // 'downloadTemplate',
    ]),
    ...mapActions('timezones', ['getTimezones']),
    ...mapActions('account', ['saveGridSettings']),
    toggleAdvancedFilters() {
      this.filtersVisible = !this.filtersVisible;
    },
    onSearch: debounce(function (name) {
      this.search({ name: name, active: this.filters.active });
    }, SEARCH_DEBOUNCE_TIME),
    openEdit(row) {
      /*this.setLastOpenedId(row.id);*/
      this.setItem({ resource: 'lastOpenedId', payload: row.id });

      this.$router.push({
        name: 'company.details',
        params: { id: row.id, companyId: row.id },
      });
    },
    redirectToAdd() {
      if(this.selectedRowItemId) {
        this.$router.push(`requirements/form?customer=${this.selectedRowItemId}`);
      } else {
        this.$router.push({
          name: 'requirements.add.new',
        });
      }
    },
    getTimezoneName(id) {
      if (id && this.timezones && this.timezones.length) {
        return this.timezones
          .filter(x => x.id == id)
          .map(x => x.displayName)
          .pop();
      }
      return '';
    },
    getAccountTypeName(accountTypes) {
      return accountTypes
        .map(type => type.accountType.name)
        .join(' / ');
    },
    handleSearchActive() {
      this.search(this.filters);
    },
    // handleSearch: debounce(function (filters) {
    //   this.search(filters);
    // }, 300),
    handleSearch(filters) {
      this.search(filters);
    },
    async onGetData(params) {
      await this.getCompanies(params);
    },
    async onDelete({ id }) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete company?`});
      if (deleteConfirmed) {
        await this.deleteRecord(id);
        this.getCompanies({});
      }
    },
    handleClearFilter() {
      this.onSearch('');
    },
    handleRowClick(row) {
      console.log('RowClick: Company id: ', row.dataItem);
      this.selectedRowItemId = row.dataItem.id;
      //this.showDetails(row.dataItem.lineId);
    },
    handleRowDoubleClick(row) {
      console.log('RowDoubleClick: Company id: ' + this.selectedRowItemId);
      this.$router.push({
        name: 'company.details.requirements',
        params: { id: this.selectedRowItemId, companyId: this.selectedRowItemId },
      });
    },
    formatUrl: function(url){
      if(url != null && !url.startsWith('http://')){
        url = 'http://' + url;
      }
      return url;
    },
    async assignBuyerSeller(){
        /*console.log('this.',this.checkedRowItemIdsArr,this.assignBuyer,this.assignSeller);*/
        if (this.checkedRowItemIdsArr.length) {
            if (this.assignBuyer) {
                await this.setBuyer({buyerId: this.assignBuyer,companyIds:this.checkedRowItemIdsArr}).then((res) => {
                  if (res.status == 200)
                    this.$snotify.success('Successfully set Buyer');
                });
            }
            if (this.assignSeller) {
                await this.setSalesperson({salesPersonId: this.assignSeller,companyIds:this.checkedRowItemIdsArr}).then((res) => {
                  if (res.status == 200)
                    this.$snotify.success('Succesfully set Sales Person');
                });
            }
            
            await this.setAlternativeSalesperson({salesPersonId: this.assignSeller2,companyIds:this.checkedRowItemIdsArr}).then((res) => {
              if (this.assignSeller2 && res.status == 200)
                this.$snotify.success('Successfully set Alternative Sales Person');
            });

            this.search(this.filters);

        }
    },
    formatNames(files) {
        return files[0].name;
      },
    onShowImportModal() {
      if (!this.isImporting) {
        this.setItem({resource: 'importProgress', payload: 0});
        this.setItem({resource: 'importLog', payload: 'Waiting for files to be imported...'});
        this.onImporting = true
      }
    },
    async onImportCompanies(e) {
      let formData = new FormData();
      this.filesUpload.forEach(element => {
        formData.append('files[]', element, element.name);
      });
      if (this.importSalesRep)
        formData.append('salesRepId', this.importSalesRep);
      if (this.importBuyerRep)
        formData.append('buyerRepId', this.importBuyerRep);
      // this.logStatus += `\nStarted importing companies...`
      this.appendImportLog(`\nStarted importing companies...`);
      this.isImporting = true;
      const result = await this.importCompanies(formData).catch(() => {
        this.isImporting = false;
        this.filesUpload = null;
        // this.logStatus += `\nThere's an error encountered during import. Please check errors within the import file.`
        this.appendImportLog(`\nThere's an error encountered during import. Please check errors within the import file.`);
      });

      if (result != null) {
        // this.logStatus += `\n---------------------------------------------------------`
        // this.logStatus += `\nSuccessfully imported companies: ${result.successCount}`
        // this.logStatus += `\nFailed imported companies: ${result.failCount}`
        this.appendImportLog(`\n---------------------------------------------------------`);
        this.appendImportLog(`\nSuccessfully imported companies: ${result.successCount}`);
        this.appendImportLog(`\nSkipped companies: ${result.skippedCount}`);
        this.appendImportLog(`\nFailed companies: ${result.failCount}`);
        if (result.failedCompanies) {
          for (let i = 0; i < result.failedCompanies.length; i++){
            this.appendImportLog(`\n* ${result.failedCompanies[i]}`);
          }  
        }
        
      }

      this.isImporting = false;
      this.onImporting = false;
      // this.$bvModal.hide('import-company');
    },
    async onMultiDeleteCompanies() {
      let response = await this.openConfirmBox({ message: 'Are you sure you want to delete the selected companies?' });
      if (response) {
        this.onMultiDeleting = true;
        await this.multiDeleteCompanies(this.checkedRowItemIdsArr).then((res) => {
          if (res)
            this.$snotify.success('Companies deleted successfully');
          else 
            this.$snotify.error('Companies deleting failed');
          this.checkedRowItemIdsArr = [];
          this.getCompanies({});
        });
        this.onMultiDeleting = false;
      }
    },
    onChangeTab(type) {
      if (this.filters.accountTypeId != type) {
        this.setItem({ resource: 'filters', payload: { ...this.filters, accountTypeId: type } });
        this.handleSearch(this.filters);  
      }
      // this.handleSearch(this.filters);  
    },
    onCustomFilterSearch(e) {
      this.handleSearch(this.filters);
    },
  },
  watch: {
    checkedRowItemIdsArr() {
      /*this.setCheckedRowItemIds(this.checkedRowItemIdsArr);*/
      this.setItem({ resource: 'checkedRowItemIds', payload: this.checkedRowItemIdsArr });
    },
    importLog() {
      var statusArea = document.getElementById('statusArea');
      statusArea.scrollTop = statusArea.scrollHeight;
    }
  },
  async mounted() {
    
    if('clear' in this.$route.query) {
      Object.keys(this.filters).forEach(filterName => {
        this.filters[filterName] = null;
      });
      this.pageInfo.pageNumber=1;
      this.clearRoute();
    } else {
      if(this.lastOpenedId) {
        this.selectedRowItemId = this.lastOpenedId;
      }
      this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
      await this.getCompanies(this.filters);
      //this.checkedRowItemIdsArr = [...this.checkedRowItemIds];
      this.getTimezones();
    }
  },
  created() {
    this.getCompanyCountByUserId(this.userId);
  },
  beforeDestroy() {
      /*this.setCheckedRowItemIds([]);*/
    this.setItem({ resource: 'checkedRowItemIds', payload: [] });
  },
};
</script>

<style lang="scss">
.companies {
    &--companies-list {
      .buttons-panel {
        text-align: right;
        margin-top: 7px;
        .btn {
          margin-left: 5px;
        }
      }
    }
  }
</style>
